export default [
  {
    path: "/",
    name: "landing",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/components/Login.vue"),
  },
];
